/* eslint-disable no-else-return */

import NotFoundPage from '@gameday/common/components/form/Common/NotFoundPage'
import { formatDateTime } from '@gameday/common/formats/dateTime.jsx'
import theme from '@gameday/react-components/utils/theme'
import lo from 'lodash'
import moment from 'moment'
import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router-dom'

import config from '../../constants/config'
import { getEventRegoFormURL, getSubdomainInHash } from '../../utils/common'
import LoadingPage from '../common/LoadingPage'
import EventInfo from './components/EventInfo'
import Footer from './components/Footer'
import Hero from './components/Hero'
// biome-ignore lint/suspicious/noShadowRestrictedNames: TODO
import Map from './components/Map'
import Nav from './components/Nav'
import OnlineDetails from './components/OnlineDetails'
import Products from './components/Products'
import Sponsors from './components/Sponsors'

const { GOOGLE_API_KEY } = config

function LandingPage({
  eventLogo,
  // headerLogo,
  getLandingPage,
  getPublicCert,
  landingPage,
  landingPageImage,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  landingPageLogo,
  sponsorLogos = {},
  setLandingPageSubdomain,
  // sponsors
}) {
  const displaySetting = landingPage.displaySetting || {
    bgGradientPrimaryColor: theme.eventsLandingPage.gradientPrimaryColor,
    bgGradientSecondaryColor: theme.eventsLandingPage.gradientSecondaryColor,
    buttonColour: theme.eventsLandingPage.buttonBgColor,
    buttonTextColour: theme.eventsLandingPage.buttonColor,
  }
  const { event } = landingPage
  const form = landingPage.form || {}
  // const sponsors = landingPage.sponsors || [] // each sponsor has id and file_url

  useEffect(() => {
    if (window.location.hash.includes('event/landing-page')) {
      setLandingPageSubdomain({ subdomain: getSubdomainInHash() })
    }
    getLandingPage()
    getPublicCert()
  }, [])

  // eslint-disable-next-line no-nested-ternary
  const timezone = event
    ? event.eventTimezone
    : // biome-ignore lint/complexity/useOptionalChain: TODO
      event && event.organisation
      ? event.organisation.timezone
      : moment.tz.guess()
  const eventStartDate =
    event && formatDateTime({ returnDateOnly: true, style: 3, value: event.startDateTime, timezone })
  const eventEndDate = event && formatDateTime({ returnDateOnly: true, style: 3, value: event.endDateTime, timezone })
  const eventStartTime =
    event && formatDateTime({ isDateOnly: false, style: 7, value: event.startDateTime, timezone, showTimezone: true })

  // biome-ignore lint/complexity/useOptionalChain: TODO
  const description = event && event.description

  const noLogos = sponsorLogos && lo.isEmpty(sponsorLogos)

  if (landingPage.formError) {
    return <NotFoundPage />
  } else if (!landingPage.event) {
    return <LoadingPage label="Loading..." />
  } else {
    return (
      <>
        <Helmet>
          <title>{event.name}</title>
          <meta name="description" content={event.name} />
        </Helmet>
        <div>
          <Nav email={event.contactEmail} logo={eventLogo} phone={event.contactPhone} title={event.name} />
          <Hero
            dateStart={eventStartDate}
            dateEnd={eventEndDate}
            email={event.contactEmail}
            gradientOne={displaySetting.bgGradientPrimaryColor}
            gradientTwo={displaySetting.bgGradientSecondaryColor}
            buttonBGColor={displaySetting.buttonColour}
            buttonTextColor={displaySetting.buttonTextColour}
            phone={event.contactPhone}
            registerURL={getEventRegoFormURL()}
            title={event.name}
            url={event.website}
            backgroundImage={landingPageImage}
            timezone={event.organisation.timezone}
          />
          {form.products.length > 0 && (
            <Products
              background={displaySetting.buttonColour}
              color={displaySetting.buttonTextColour}
              products={form.products}
              signupURL={getEventRegoFormURL()}
            />
          )}
          {description && (
            <EventInfo
              info={description}
              href={getEventRegoFormURL()}
              background={displaySetting.buttonColour}
              color={displaySetting.buttonTextColour}
            />
          )}
          {sponsorLogos && !noLogos && <Sponsors sponsors={sponsorLogos} />}
          {event.category === 'Online' ? (
            <OnlineDetails
              backgroundImage={landingPageImage}
              date={eventStartDate}
              time={eventStartTime}
              allDayEvent={event.allDayEvent}
            />
          ) : (
            <Map
              lat={event.latitude}
              lng={event.longitude}
              date={eventStartDate}
              time={eventStartTime}
              venue={{
                name: event.venueName,
                street: event.street,
                city: event.city,
                state: event.state,
                postcode: event.postalCode,
                country: event.country,
              }}
              mapKey={GOOGLE_API_KEY}
              color={displaySetting.buttonColour}
              allDayEvent={event.allDayEvent}
            />
          )}
          <Footer logo={eventLogo} title={event.name} />
        </div>
      </>
    )
  }
}

export default withRouter(LandingPage)
